// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".one-filters__header[data-v-1170ab50],.one-filters__pointer[data-v-1170ab50]{background-color:#fff}.one-filters__header[data-v-1170ab50]{border-left:2px solid var(--primary-color);border-bottom:2px solid #e6e8eb;padding:.5rem 0 .5rem .5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
